import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'decimalSeparator',
  standalone: true
})
export class DecimalSeparatorPipe implements PipeTransform {
  transform(value: string, separator: ',' | '.' = ','): string {
    if (!value) return value;

    const from = separator === ',' ? '.' : ',';
    return value.replace(from, separator);
  }
}
